import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxiosClientsContextProvider } from 'shared/axios/axios-clients-provider';
import ConnectorExistsResponse from 'shared/providers/connector/domain/models/connector-exists-response';

import { ConnectorType } from 'features/connectors/domain/connector';

const connectorBaseUrl = '/api/v1/Connector';

export const VcareConnectorQueryPaths = {
  ConnectorExists: 'ConnectorExists',
};

const connectorExists = async (axiosInstance: AxiosInstance, connectorType: ConnectorType): Promise<boolean> => {
  const response = await axiosInstance.get<ConnectorExistsResponse>(
    `${connectorBaseUrl}/${VcareConnectorQueryPaths.ConnectorExists}/${connectorType}`,
  );

  return response.data.exists;
};

export const useGetVcareConnectorExistsQuery = (enabled: boolean): UseQueryResult<boolean> => {
  const { authenticatedInstance } = useAxiosClientsContextProvider();
  return useQuery({
    queryKey: [VcareConnectorQueryPaths.ConnectorExists],
    queryFn: () => connectorExists(authenticatedInstance, ConnectorType.Vcare),
    enabled,
  });
};
